import { getApiData, hasData } from 'scenes/common/helpers/apiData';

import { HomeFunnelState } from 'scenes/home/types';
import { Campaign, CampaignAdjustment } from 'scenes/common/types';
import { campaignFlowMapping } from '../helpers/campaign';

export const filteredCampaign = (
  campaign: Campaign,
  state: HomeFunnelState
): Campaign => ({
  ...campaign,
  elements: campaign.elements.filter((element) =>
    campaignFlowMapping[element.type].includes(state.flow)
  ),
});

export const getCampaign = (state: HomeFunnelState): Campaign | undefined => {
  if (hasData(state.apiResponses.quoteDetails)) {
    const { campaigns } = getApiData(state.apiResponses.quoteDetails);
    if (campaigns && campaigns.length > 0) {
      return filteredCampaign(campaigns?.[0], state);
    }
  } else if (hasData(state.apiResponses.campaign)) {
    if (hasData(state.apiResponses.campaign)) {
      const campaign = getApiData(state.apiResponses.campaign);
      if (campaign) {
        return filteredCampaign(campaign, state);
      }
    }
  }

  return undefined;
};

export const getCampaignAdjustments = (
  state: HomeFunnelState
): CampaignAdjustment[] => {
  if (hasData(state.apiResponses.quoteDetails)) {
    const { campaigns } = getApiData(state.apiResponses.quoteDetails);
    return campaigns?.[0]?.adjustments ?? [];
  }

  return [];
};

export const getAppliedCampaignId = (state: HomeFunnelState): string => {
  if (hasData(state.apiResponses.quoteDetails)) {
    const { campaigns } = getApiData(state.apiResponses.quoteDetails);
    if (campaigns && campaigns.length > 0) {
      return campaigns?.[0].id;
    }
  }

  return '';
};
